import * as yup from 'yup';
import i18n from '../../../../localization/i18n';
import {
    LABEL_FIELD_ERROR_REQUIRED,
    VEHICLEINFO_MILEAGE_ERROR,
    VEHICLEINFO_VIN_ERROR,
} from '../../../../localization/resouceKeys';

export const vehicleInfoValidations = yup.object().shape({
    vehicleMileage: yup
        .string()
        .required(() => i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .matches(
            // eslint-disable-next-line max-len
            /^[1-9]{1}[0-9]{0,5}$/i,
            () => i18n.t(VEHICLEINFO_MILEAGE_ERROR),
        ),
    vehicleVin: yup.string().matches(
        // eslint-disable-next-line max-len
        /^[a-hj-npr-zA-HJ-NPR-Z0-9]{17}$/i,
        () => i18n.t(VEHICLEINFO_VIN_ERROR),
    ),
    vehicleYear: yup.string().test(
        'len',
        () => i18n.t(LABEL_FIELD_ERROR_REQUIRED),
        (val) => {
            if (val) {
                return val.length > Number('0');
            } else return false;
        },
    ),
    vehicleMake: yup.string().test(
        'len',
        () => i18n.t(LABEL_FIELD_ERROR_REQUIRED),
        (val) => {
            if (val) return val.length > Number('0');
            else return false;
        },
    ),
    vehicleBody: yup.string().test(
        'len',
        () => i18n.t(LABEL_FIELD_ERROR_REQUIRED),
        (val) => {
            if (val) return val.length > Number('0');
            else return false;
        },
    ),
    vehicleModel: yup.string().test(
        'len',
        () => i18n.t(LABEL_FIELD_ERROR_REQUIRED),
        (val) => {
            if (val) return val.length > Number('0');
            else return false;
        },
    ),
});
